import { render, staticRenderFns } from "./ReviewsAndAwards.vue?vue&type=template&id=0a142026&scoped=true"
import script from "./ReviewsAndAwards.vue?vue&type=script&lang=js"
export * from "./ReviewsAndAwards.vue?vue&type=script&lang=js"
import style0 from "./ReviewsAndAwards.vue?vue&type=style&index=0&id=0a142026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a142026",
  null
  
)

export default component.exports